import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FreelancerJoinPage } from "@/features/freelancerjoin/FreelancerJoinPage";

const search = z.object({
  step: z.enum(["profile", "tax", "nda", "id", "insurance", "payouts"]).optional(),
});

/** Public freelancer onboarding for one freelancer. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/freelancer/$token")({
  validateSearch: search,
  component: FreelancerJoinRoute,
});

function FreelancerJoinRoute() {
  const { token } = Route.useParams();
  return <FreelancerJoinPage token={token} search={Route.useSearch()} />;
}
